<template>
  <a-modal
    :title="title"
    :width="820"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :hidden="true"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="日期"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="['date', {rules: [{required: false, message: '请选择日期'}]}]"></a-date-picker>
        </a-form-item>
        <a-form-item
          label="项目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        > <a-select
          showSearch
          :disabled="showable"
          placeholder="请选择"
          v-decorator="['projectId', {rules: [{required: false, message: '请选择项目'}]}]"
          :options="projectList"
          optionFilterProp="children"
        />
        </a-form-item>
        <a-form-item
          label="类型"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择类型"
            showSearch
            :filterOption="filterOption"
            :disabled="showable"
            :options="this.typeList"
            v-decorator="['type', {rules: [{required: false, message: '请选择工人类别'}]}]" />
        </a-form-item>
        <a-form-item
          label="分包商/费用分摊名称"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            v-decorator="['subcontractor', {rules: [{required: false, message: '请输入分包商/费用分摊名称'}]}]"
            placeholder="请输入分包商/费用分摊名称"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="分包结算、支付情况/费用分摊内容"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            v-decorator="['content', {rules: [{required: false, message: '请输入分包结算、支付情况/费用分摊内容'}]}]"
            placeholder="请输入分包结算、支付情况/费用分摊内容"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="分包完成额/费用分摊额"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            placeholder="请输入分包完成额/费用分摊额"
            v-decorator="['amount', {rules: [{required: false, message: '请输入分包完成额/费用分摊额'}]}]"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="分包已支付额"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            placeholder="请输入分包已支付额"
            v-decorator="['paid', {rules: [{required: false, message: '请输入分包已支付额'}]}]"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="备注"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-textarea
            :rows="4"
            placeholder="请输入备注"
            v-decorator="['remark', {rules: [{required: false, message: '请输入备注'}]}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable || linkable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { dropProjectByType } from '@/api/project/ProjectInfo'
import { addObjCuring, getObj, putObj } from '@/api/daily/subcontract'

export default {
  name: 'CuringSubcontractAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      projectList: [], // 项目
      typeList: [
        {
          label: '分包费用',
          value: 'assessment'
        },
        {
          label: '费用分摊',
          value: 'subcontracting'
        }]
    }
  },
  methods: {
    edit (id, type) {
      dropProjectByType('curing').then(res => {
        this.projectList = res.data
      })
      this.list = []
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show', 'link', 'removeLink'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          record.date = moment(record.date)
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'date', 'type', 'subcontractor', 'content', 'amount', 'paid', 'remark']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObjCuring(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
